"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldJoinMatch = void 0;
/** Two joins that match each other.
 *
 * This interface does not accept CollectionModelFields because Angular uses it.
 */
var FieldJoinMatch = /** @class */ (function () {
    function FieldJoinMatch() {
        var joins = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            joins[_i] = arguments[_i];
        }
        this.fieldJoins = joins;
    }
    FieldJoinMatch.prototype.getJoin = function (subformInstanceID, fieldName) {
        for (var _i = 0, _a = this.fieldJoins; _i < _a.length; _i++) {
            var join = _a[_i];
            if (join.field.parent.instanceId === subformInstanceID && join.field.schema.id === fieldName) {
                return join;
            }
        }
        return undefined;
    };
    FieldJoinMatch.prototype.getOppositeJoin = function (subformInstanceID, fieldName) {
        var join = this.getJoin(subformInstanceID, fieldName);
        if (join == null) {
            return undefined;
        }
        return this.fieldJoins.find(function (fieldJoin) { return fieldJoin !== join; });
    };
    return FieldJoinMatch;
}());
exports.FieldJoinMatch = FieldJoinMatch;
//# sourceMappingURL=field.join.js.map